import { TFunction } from "i18next";

import { MaterialUploadError } from "shared";

export const formatErrorWithLocation = (error: MaterialUploadError, t: TFunction): string => {
  const message = t(`settings.materials.upload.errors.${error.code}`, {
    field: error.field,
    value: error.value,
    ...error.context,
  });

  if (error.row !== undefined) {
    if (error.field) {
      const location = t("settings.materials.upload.errorAtRowWithField", {
        row: error.row,
        field: error.field,
      });
      return `${location}: ${message}`;
    } else {
      const location = t("settings.materials.upload.errorAtRow", {
        row: error.row,
      });
      return `${location}: ${message}`;
    }
  }

  return message;
};
